import { Wrapper, Title, Description } from './styled'

type EmptyListProps = {
  title?: string
  description?: string
}

export function EmptyList({ title, description }: EmptyListProps) {
  return (
    <Wrapper>
      <Title>{title || 'У вас ещё нет транзакций'}</Title>
      <Description>
        {description ||
          'Здесь будет отображаться история списаний и пополнений вашего счёта'}
      </Description>
    </Wrapper>
  )
}
